import { useState, useEffect } from 'react'
import { WifiSlash, CheckCircle } from '@phosphor-icons/react'
import { getQueuedAttendanceCount } from '../utils/registerServiceWorker'

export default function OfflineIndicator() {
  const [isOnline, setIsOnline] = useState(navigator.onLine)
  const [queuedCount, setQueuedCount] = useState(0)

  useEffect(() => {
    const handleOnline = () => {
      setIsOnline(true)
      setTimeout(() => checkQueue(), 1000) // Check queue after sync
    }
    
    const handleOffline = () => setIsOnline(false)
    
    window.addEventListener('online', handleOnline)
    window.addEventListener('offline', handleOffline)
    
    checkQueue()
    
    return () => {
      window.removeEventListener('online', handleOnline)
      window.removeEventListener('offline', handleOffline)
    }
  }, [])

  const checkQueue = async () => {
    const count = await getQueuedAttendanceCount()
    setQueuedCount(count)
  }

  if (isOnline && queuedCount === 0) return null

  return (
    <div className={`fixed top-4 left-1/2 -translate-x-1/2 z-50 px-4 py-2 rounded-full shadow-lg flex items-center gap-2 ${
      isOnline ? 'bg-green-500' : 'bg-orange-500'
    } text-white text-sm font-medium`}>
      {isOnline ? (
        <>
          <CheckCircle size={16} weight="fill" />
          <span>Syncing {queuedCount} attendance...</span>
        </>
      ) : (
        <>
          <WifiSlash size={16} weight="fill" />
          <span>Offline Mode - {queuedCount} queued</span>
        </>
      )}
    </div>
  )
}